<div class="d-flex " [class.justify-content-end]="message.reply">
  <div class="d-flex flex-column">
    <div class="message-box mt-3" [class.sender]="!message.reply">
      <nb-user size="small"
             [name]="senderName"
             >
    </nb-user>
      <div class="message">
        <div class="message-content">
        <p class="message-text m-0" *ngIf="message.message" [innerHtml]="message.message"></p>
        <app-file-message-viewer [files]="message.files"></app-file-message-viewer>
        <div class="message-time text-right">{{formatDate(message.dateTime)}}
          <nb-icon [icon]="message.seen? 'done-all-outline': 'checkmark-outline'"></nb-icon>
        </div>
      </div>
      </div>
    </div>
  </div>
</div>
